import { Turbo } from "@hotwired/turbo-rails";

Turbo.StreamActions.append_row_to_table = function () {
  const tableElement = this.targetElements[0];

  const limit = parseInt(tableElement.getAttribute("data-limit")) || Infinity;
  const removeFrom = this.getAttribute("remove-from") || "bottom";

  if (!tableElement) {
    return;
  }

  let tbody = tableElement.querySelector("tbody");
  if (!tbody) {
    return;
  }

  tbody.prepend(this.templateContent);

  // Управление лимитом: удаляем лишние строки
  if (limit < Infinity) {
    let rows = tbody.querySelectorAll("tr");
    while (rows.length > limit) {
      const rowToRemove =
        removeFrom === "top" ? rows[0] : rows[rows.length - 1];
      rowToRemove.remove();
      rows = tbody.querySelectorAll("tr");
    }
  }
};
